// CSS Modules - component class name: NewsletterForm__

<template>
  <div>
    <form v-if="!stepOneComplete" :class="$style.container">
      <p :class="$style.text">{{ config.text }}</p>
      <div class="columns">
        <div class="column is-half-tablet">
          <FormInput
            v-model.trim="$v.formData.email.$model"
            :label="config.labels.email.label"
            :boldLabel="true"
            :errorMessage="config.labels.email.errorMessage"
            :error="$v.formData.email.$error && $v.$dirty && isStepOneSubmitted"
            :originalValue="
              previousData.email && previousData.email !== ''
                ? previousData.email
                : null
            "
            :formSubmitSwitch="formSubmitSwitch"
          />
        </div>
      </div>
      <div :class="$style.serverError" v-if="serverError">
        {{ config.serverErrorMessage }}
      </div>
      <div :class="$style.serverError" v-if="noSubscriptionsError">
        {{ config.noSubscriptionsErrorMessage }}
      </div>
      <div class="columns">
        <div class="column has-text-right-tablet">
          <Button
            colour="blue"
            :text="config.firstButtonText"
            type="submit"
            :isForm="true"
            @close="handleStepOneSubmit"
          >
          </Button>
        </div>
      </div>
      <ReCaptcha :executeSwitch="executeSwitch" :submit="stepOneSubmit" />
    </form>
    <form v-else :class="$style.container">
      <p :class="$style.stepTwoTitle">{{ config.optionalSectionTitle }}</p>
      <p :class="$style.text">
        <span v-if="checkboxes.length > 1">{{
          config.optionalSectionTextPartOne
        }}</span>
        <span>{{ config.optionalSectionTextPartTwo }}</span>
      </p>
      <div :class="[$style.checkboxes, 'columns is-mobile is-multiline']">
        <div
          v-for="(checkbox, index) in checkboxes"
          :key="`checkbox-${index}`"
          class="column is-half"
        >
          <input
            :id="`checkbox-${index}`"
            type="checkbox"
            :name="`checkbox-${index}`"
            :value="checkbox.newsletterId"
            v-model="selectedIds"
          />
          <label :for="`checkbox-${index}`">{{ checkbox.label }}</label>
        </div>
      </div>
      <div :class="$style.serverError" v-if="serverError">
        {{ config.serverErrorMessage }}
      </div>
      <div :class="$style.serverSuccess" v-if="serverSuccess">
        {{ config.unsubscribeSuccess }}
      </div>
      <div :class="$style.serverError" v-if="checkboxError">
        {{ config.checkboxErrorMessage }}
      </div>
      <div class="columns">
        <div class="column has-text-right-tablet">
          <Button
            colour="blue"
            :text="config.secondButtonText"
            type="submit"
            :isForm="true"
            @close="handleStepTwoSubmit"
          >
          </Button>
        </div>
      </div>
      <ReCaptcha :executeSwitch="executeSwitch" :submit="stepTwoSubmit" />
    </form>
  </div>
</template>

<script>
import { email, required } from "vuelidate/lib/validators";
import ReCaptcha from "../ReCaptcha/ReCaptcha";
import FormInput from "../FormInput/FormInput";
import Button from "../Button/Button";
import axios from "axios";

export default {
  name: "NewsletterUnsubscribe",
  components: {
    ReCaptcha,
    Button,
    FormInput
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formData: {
        newsletter: "",
        email: "",
        domain: "",
        pageUrl: "",
        token: ""
      },
      checkboxes: [],
      newsletterIds: [],
      selectedIds: [],
      previousData: {},
      isStepOneSubmitted: false,
      formSubmitSwitch: false,
      executeSwitch: false,
      stepOneComplete: false,
      showThankyou: false,
      serverError: false,
      serverSuccess: false,
      noSubscriptionsError: false,
      checkboxError: false
    };
  },
  validations: {
    formData: {
      email: {
        required,
        email
      }
    }
  },
  mounted() {
    if (this.config.newsletters) {
      for (const newsletter of this.config.newsletters) {
        this.newsletterIds.push(parseFloat(newsletter.newsletterId));
      }
    }
  },
  methods: {
    handleStepOneSubmit() {
      this.serverError = false;
      this.serverSuccess = false;
      this.$v.$touch();
      this.isStepOneSubmitted = true;
      this.formSubmitSwitch = !this.formSubmitSwitch;
      if (!this.$v.$invalid) {
        this.executeSwitch = !this.executeSwitch;
      } else {
        this.previousData = JSON.parse(JSON.stringify(this.formData));
      }
    },
    initStepTwo(data) {
      this.checkboxes = [];
      for (const id of data) {
        const item = {
          newsletterId: id.toString(),
          label: this.config.newsletters[this.newsletterIds.indexOf(id)].label
        };
        this.checkboxes.push(item);
      }
      this.stepOneComplete = true;
    },
    handleStepTwoSubmit() {
      this.serverError = false;
      this.serverSuccess = false;
      this.noSubscriptionsError = false;
      this.checkboxError = false;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.selectedIds.length !== 0) {
          this.executeSwitch = !this.executeSwitch;
        } else {
          this.checkboxError = true;
        }
      } else {
        this.previousData = JSON.parse(JSON.stringify(this.formData));
      }
    },
    stepOneSubmit(token) {
      this.formData.token = token;
      this.formData.domain = window.location.origin;
      this.formData.pageUrl = window.location.pathname;
      axios({
        url: window.newsletterGetSubscriptionsUrl,
        method: "get",
        responseType: "json",
        params: {
          email: this.formData.email,
          listIds: this.newsletterIds.toString()
        }
      })
        .then(response => {
          if (response.status === 200 && response.data.length !== 0) {
            this.initStepTwo(response.data);
          } else {
            this.serverError = true;
          }
        })
        .catch(error => {
          if (error.response.status === 500) {
            this.noSubscriptionsError = true;
          } else {
            this.serverError = true;
          }
          console.error(error);
        });
    },
    stepTwoSubmit(token) {
      this.formData.token = token;
      this.formData.domain = window.location.origin;
      this.formData.pageUrl = window.location.pathname;
      let combinedRequests = [];
      for (const id of this.selectedIds) {
        this.formData.newsletter = id;
        combinedRequests.push(
          axios({
            url: window.newsletterUnsubscribeUrl,
            method: "post",
            data: { ...this.formData },
            responseType: "json"
          })
        );
      }
      axios
        .all(combinedRequests)
        .then(
          axios.spread((...responses) => {
            if (responses.every(response => response.status === 200)) {
              this.serverSuccess = true;
            } else {
              this.serverError = true;
              this.serverSuccess = false;
            }
          })
        )
        .catch(errors => {
          this.serverError = true;
          this.serverSuccess = false;
          console.error(errors);
        });
    }
  }
};
</script>

<style module lang="scss">
@import "./NewsletterForm.scss";
</style>
